import { DateTimeBox, DateTimeBoxLayoutStyle } from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';

export const TargetClosingDateField = () => {
    const value = useWizardDemoStore((state) => state.applicationKeyItems.targetClosingDate);
    const updateApplicationKeyItems = useWizardDemoStore((state) => state.updateApplicationKeyItems);

    return (
        <DateTimeBox
            id='applicationTargetClosingDate'
            value={value}
            onChange={(targetClosingDate) => updateApplicationKeyItems({ targetClosingDate })}
            // DateTimeBox doesn't call onChange when the date is cleared (or an invalid date is rejected); it only
            // fails validation. Treat a failed validation as "no date" so the form (and step progress) reflects it.
            onValidationEvent={(isValid) => {
                if (!isValid) {
                    updateApplicationKeyItems({ targetClosingDate: undefined });
                }
            }}
            label='Target Closing Date'
            required={true}
            width={'160px'}
            placeholder='MM/DD/YYYY'
            layoutStyle={DateTimeBoxLayoutStyle.Horizontal}
            labelWidth='180px'
            height='36px'
        />
    );
};
